export const DEFAULT_ROLE_FILTER = 'all';

export const formatRoleLabel = (role = '') =>
  String(role)
    .replace(/_/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
